import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || ''
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || ''

const isConfigured = supabaseUrl.startsWith('http') && supabaseAnonKey.length > 5 && !supabaseUrl.includes('placeholder')

let supabase

try {
  supabase = createClient(supabaseUrl, supabaseAnonKey)
} catch (e) {
  supabase = null
}

const MOCK_MOVIES = [
  {
    id: '1', slug: 'sample-movie-1', title: 'Sample Movie 1', 
    description: 'Ini film contoh. Database belum terkonfigurasi.',
    type: 'movie', year: 2025, genres: ['Action', 'Adventure'],
    poster_url: 'https://placehold.co/300x450/1f1f1f/e50914?text=ICLIX',
    backdrop_url: 'https://placehold.co/1280x720/141414/e50914?text=ICLIX',
    embed_url: '', duration: '2h 15min', status: 'active'
  },
  {
    id: '2', slug: 'sample-movie-2', title: 'Sample Series',
    description: 'Database Supabase belum disetup. Jalankan supabase_schema.sql dan isi data.',
    type: 'series', year: 2025, genres: ['Drama', 'Thriller'],
    poster_url: 'https://placehold.co/300x450/1f1f1f/e50914?text=SERIES',
    backdrop_url: 'https://placehold.co/1280x720/141414/e50914?text=SERIES',
    embed_url: '', duration: '45min', status: 'active'
  },
  { id: '3', slug: 'shrek', title: 'Shrek 2', type: 'movie', year: 2004, genres: ['Animation', 'Comedy'], poster_url: 'https://placehold.co/300x450/1f1f1f/e50914?text=SHREK', backdrop_url: 'https://placehold.co/1280x720/141414/e50914?text=SHREK', embed_url: '', duration: '1h 33min', status: 'active', description: 'Shrek and Fiona travel to the Kingdom of Far Far Away to meet her parents.' },
  { id: '4', slug: 'interstellar', title: 'Interstellar', type: 'movie', year: 2014, genres: ['Sci-Fi', 'Drama'], poster_url: 'https://placehold.co/300x450/1f1f1f/e50914?text=INTERSTELLAR', backdrop_url: 'https://placehold.co/1280x720/141414/e50914?text=INTERSTELLAR', embed_url: '', duration: '2h 49min', status: 'active', description: "When Earth becomes uninhabitable, a farmer and ex-NASA pilot is tasked with piloting a spacecraft along with a team of researchers to find a new planet for humans." },
  { id: '5', slug: 'spiderverse', title: 'Spider-Man: Into the Spider-Verse', type: 'movie', year: 2018, genres: ['Animation', 'Action'], poster_url: 'https://placehold.co/300x450/1f1f1f/e50914?text=SPIDERVERSE', backdrop_url: 'https://placehold.co/1280x720/141414/e50914?text=SPIDERVERSE', embed_url: '', duration: '1h 57min', status: 'active', description: 'Teen Miles Morales becomes the Spider-Man of his universe.' },
  { id: '6', slug: 'demon-slayer', title: 'Demon Slayer', type: 'series', year: 2019, genres: ['Animation', 'Action'], poster_url: 'https://placehold.co/300x450/1f1f1f/e50914?text=DEMONSLAYER', backdrop_url: 'https://placehold.co/1280x720/141414/e50914?text=DEMONSLAYER', embed_url: '', duration: '24min', status: 'active', description: 'A family is attacked by demons and only two members survive.' },
]

export async function getMovies(category = 'popular', page = 1) {
  if (!isConfigured || !supabase) return MOCK_MOVIES
  try {
    const { data, error } = await supabase
      .from('movies').select('*').order('created_at', { ascending: false })
      .range((page - 1) * 20, page * 20 - 1)
    if (error) throw error
    return data
  } catch { return MOCK_MOVIES }
}

export async function getMovieBySlug(slug) {
  const movie = MOCK_MOVIES.find(m => m.slug === slug)
  if (!isConfigured || !supabase) return movie || null
  try {
    const { data, error } = await supabase.from('movies').select('*').eq('slug', slug).single()
    if (error) throw error
    return data
  } catch { return movie || null }
}

export async function searchMovies(query) {
  if (!isConfigured || !supabase) {
    const q = query.toLowerCase()
    return MOCK_MOVIES.filter(m => m.title.toLowerCase().includes(q))
  }
  try {
    const { data, error } = await supabase.from('movies').select('*').ilike('title', `%${query}%`).limit(20)
    if (error) throw error
    return data
  } catch { return [] }
}

export async function getGenres() {
  const genres = [...new Set(MOCK_MOVIES.flatMap(m => m.genres))].map((g, i) => ({ id: String(i + 1), slug: g.toLowerCase(), name: g, type: 'both' }))
  if (!isConfigured || !supabase) return genres
  try {
    const { data, error } = await supabase.from('genres').select('*').order('name')
    if (error) throw error
    return data
  } catch { return genres }
}

export async function getMoviesByGenre(genreSlug, page = 1) {
  if (!isConfigured || !supabase) return MOCK_MOVIES.filter(m => m.genres.map(g => g.toLowerCase()).includes(genreSlug.toLowerCase()))
  try {
    const { data, error } = await supabase.from('movies').select('*').contains('genres', [genreSlug]).range((page - 1) * 20, page * 20 - 1)
    if (error) throw error
    return data
  } catch { return [] }
}

export async function getUserProfile(userId) {
  if (!isConfigured || !supabase) return null
  try {
    const { data, error } = await supabase.from('profiles').select('*').eq('id', userId).single()
    if (error && error.code !== 'PGRST116') throw error
    return data
  } catch { return null }
}

export async function updateProfile(userId, updates) {
  if (!isConfigured || !supabase) return
  try {
    const { error } = await supabase.from('profiles').upsert({ id: userId, ...updates })
    if (error) throw error
  } catch {}
}

export { supabase, isConfigured }
